
import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-revise-question',
  templateUrl: './revise-question.component.html',
  styleUrls: ['./revise-question.component.css']
})
export class ReviseQuestionComponent implements OnInit {
  @Input() question = undefined

  renderMathNow=false
  questionId=0
  answerValue=""

  constructor() { }

  ngOnInit(): void {

  }
  isCorrectChoice(choice){
    return choice.name =="answer"
  }




}

